import GenericDateRange from "@/components/dateTime/genericDateRange";
import GenericCrudTableDurationFilter from "@/components/tables/genericCrudTableDurationFilter";
import {
  isDateRangeFilterEnabled,
  type GenericCrudTableDateColumnDef,
} from "@/components/dateTime/genericDateFilterUtils";

export interface GenericCrudTableFilterColumnDef {
  id?: string;
  filterVariant?: string;
  minSize?: number;
  enableColumnFilterModes?: boolean;
  Filter?: unknown;
  allowDateRangeFiltering?: boolean;
}

export type NormalizeCustomFilterColumnsOptions = {
  columnMinSize?: number;
  allowsDateRangeFilters?: boolean;
};

export const normalizeCustomFilterColumns = <
  T extends GenericCrudTableFilterColumnDef & GenericCrudTableDateColumnDef,
>(
  columns: T[],
  options?: NormalizeCustomFilterColumnsOptions,
): T[] =>
  (columns || []).map((col) => {
    if (isDateRangeFilterEnabled(col, options?.allowsDateRangeFilters)) {
      return {
        ...col,
        minSize: col.minSize ?? options?.columnMinSize ?? 240,
        enableColumnFilterModes: false,
        Filter: col.Filter ?? GenericDateRange,
      } as T;
    }

    if (col.filterVariant === "duration") {
      return {
        ...col,
        minSize: col.minSize ?? options?.columnMinSize ?? 180,
        enableColumnFilterModes: false,
        Filter: col.Filter ?? GenericCrudTableDurationFilter,
      } as T;
    }

    return col;
  });
